import { defineStore } from "pinia";
import { computed, ref } from "vue";

import { getAxiosInstance } from "@/axiosClient";

export const useMiTiendaStore = defineStore("mitienda", () => {
  // State
  const miTiendaToken = ref(null);
  const loading = ref(false);

  // Getters
  const getMiTiendaToken = computed(() => miTiendaToken.value);

  // Actions
  const setMiTiendaToken = (token) => {
    miTiendaToken.value = token;
  };

  const fetchMiTiendaURL = async () => {
    // Si ya tenemos el token, devolverlo
    if (miTiendaToken.value !== null) {
      return miTiendaToken.value;
    }

    // Si ya hay una llamada en progreso, esperar a que termine
    if (loading.value) {
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (!loading.value && miTiendaToken.value !== null) {
            clearInterval(checkInterval);
            resolve(miTiendaToken.value);
          }
        }, 50);
      });
    }

    try {
      loading.value = true;
      const axios = getAxiosInstance();
      const response = await axios.get(`/api/mitienda`);
      miTiendaToken.value = response.data;
      return miTiendaToken.value;
    } catch (error) {
      console.error("Error fetching mi tienda:", error);
    } finally {
      loading.value = false;
    }
  };

  const resetState = () => {
    miTiendaToken.value = null;
  };

  return {
    // State
    miTiendaToken,
    // Getters
    getMiTiendaToken,
    // Actions
    setMiTiendaToken,
    fetchMiTiendaURL,
    resetState,
  };
});
